import * as React from 'react';

import { CardController } from 'src/app/shared/card.controller';
import { AgentGeneralPartView } from './agent-general.view';

interface Props extends ComponentViewProps<AgentItem> {
	isNew: boolean;
	mode: ControlMode;
	currency: CurrencySummary;
	onChangeCurrency: (currency: CurrencySummary) => void;
}

export class AgentGeneralPartController extends React.Component<Props, {}> {
	constructor(props: Readonly<Props>) {
		super(props);

		this.state = {
			currency: null
		};
	}

	render() {
		const { model, isNew, mode, currency, onChangeCurrency, setBusy } = this.props;
		if (model == null) {
			return null;
		}

		return (
			<CardController
				icon="user"
				className="card-borderless"
				title="General information"
				mode={mode}>
				<AgentGeneralPartView
					model={model}
					isNew={isNew}
					mode={mode}
					currency={currency}
					onChangeCurrency={onChangeCurrency}
					setBusy={setBusy}
				/>
			</CardController>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/agents/form/parts/agent-general.controller.tsx